module.exports = __webpack_public_path__ + "static/img/sc15.42d73c0.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/sc15.png
// module id = 30l0
// module chunks = 25